import React, { useMemo } from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { Popover } from 'antd';

import StepPopupUnassign from './StepPopupUnassign';
import { STEP_TYPE } from '../../constants';

const UnScheduledSteps = ({
  steps,
  realSteps,
  stepsHovered,
  setStepsHovered,
  onClickStep,
  handleCloseStepPopup,
  setting,
  selectedMultipleSteps,
  multipleStepState,
  selectedStep,
  searchStopsMap,
}) => {
  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, 'unscheduled');
    } else {
      onClickStep(step);
    }
  };

  const filteredSteps = useMemo(() => {
    return steps
      .filter((step) => {
        return (
          step.address?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
          step.driverName?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
          step.name?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
          step.orderCode?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
          step.partner?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
          step.volume?.toString().toLowerCase().match(searchStopsMap.toLowerCase())
        );
      })
      .map((step) => step.orderCode);
  }, [steps, searchStopsMap]);
  return (
    <>
      {steps.map((step) => {
        // For delivery, find by matching any orderId in orderIds; for pickup, use first orderId
        const stepOrderIds = step.orderIds || (step.orderId ? [step.orderId] : []);
        const keyIndex = realSteps.findIndex((rs) => {
          const rsOrderIds = rs.orderIds || (rs.orderId ? [rs.orderId] : []);
          return rs.type === STEP_TYPE.delivery && stepOrderIds.some((orderId) => rsOrderIds.includes(orderId));
        });
        const keyDraggable = `draggable${step.id}${keyIndex}`;
        const stepPopover = `StepPopover-${stepOrderIds[0] || step.id}-${step.type.toLowerCase()}`;
        const isMultipleSelected = multipleStepState?.steps?.find((item) => {
          const itemOrderIds = item.orderIds || (item.orderId ? [item.orderId] : []);
          return (
            stepOrderIds.some((orderId) => itemOrderIds.includes(orderId)) &&
            item.type === step.type &&
            item.driverId === 'unscheduled'
          );
        });
        return (
          <Draggable key={keyDraggable} draggableId={keyDraggable} index={keyIndex}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                  zIndex: 99,
                  width: 24,
                  marginLeft: '8px',
                  ...provided.draggableProps.style,
                }}
              >
                <Popover
                  key={keyIndex}
                  trigger="hover"
                  open={stepsHovered[stepPopover] || false}
                  content={
                    <StepPopupUnassign
                      step={step}
                      stepPopover={stepPopover}
                      setStepsHovered={setStepsHovered}
                      onClickStep={onClickStep}
                      setting={setting}
                    />
                  }
                >
                  <div
                    className={`${step.type.toLowerCase() === 'pickup' ? 'unit' : 'unit unit2'} ${stepPopover}`}
                    style={{
                      borderColor: step.color,
                      color: step.color,
                      borderWidth: isMultipleSelected || selectedStep?.id === step.id ? '3px' : '1px',
                      opacity: filteredSteps.includes(step.orderCode) ? 1 : 0.3,
                    }}
                    onClick={(e) => newClickStep(e, step)}
                    onMouseOut={() => handleCloseStepPopup()}
                  >
                    {step.index}
                  </div>
                </Popover>
              </div>
            )}
          </Draggable>
        );
      })}
    </>
  );
};

export default UnScheduledSteps;
